import React, { use, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { BrowserView, MobileView } from 'react-device-detect';
import { PatternFormat } from 'react-number-format';
import {
   whatsappListaContatosFlagsAction,
   WhatsappInsertContatoParcAction,
   WhatsappUpdateContatoParcAction,
   WhatsappContatoGeralListAction
} from '../../actions/WhatsappActions';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
   Icon, Button, Divider, Input, Message, Card, Form, Header, HeaderContent, HeaderSubheader,
   ModalHeader,
   ModalDescription,
   ModalContent,
   ModalActions,
   Modal,
   Dropdown,
   FormGroup,
   FormCheckbox,
   Label
} from 'semantic-ui-react';
import { DebounceInput } from 'react-debounce-input';

function Whatsapp(props) {

   //actions
   const {
      WhatsappContatoGeralListAction,
      whatsappListaContatosFlagsAction,
      WhatsappUpdateContatoParcAction,
      WhatsappInsertContatoParcAction
   } = props;
   //props reducer
   const { contatosList, contatosParcUpdateLoader,
      contatosParcInsertLoader, codusu, buscarCodparc, buscarId,
      contatosLoading, contatosListGeral, contatosGeralLoading } = props;

   const [errors, setErrors] = useState([]);

   const [contatos, setContatos] = useState([]);
   const [contatosGeral, setContatosGeral] = useState([]);

   useEffect(() => {
      //console.log('Whatsapp contatosList payload:', contatosList);
      if (Array.isArray(contatosList)) {
         setContatos(contatosList);
      } else {
         setContatos([]);
      }
   }, [contatosList]);

   useEffect(() => {
      //console.log('Whatsapp contatosListGeral payload:', contatosListGeral);
      if (Array.isArray(contatosListGeral)) {
         setContatosGeral(contatosListGeral);
      } else {
         setContatosGeral([]);
      }
   }, [contatosListGeral]);

   const [errorSaving, setErrorSaving] = useState([]);
   const [successMessage, setSuccessMessage] = useState('');
   const [searchValue, setSearchValue] = useState('');

   const [searchLoading, setSearchLoading] = useState(false)

   const [open, setOpen] = useState(false)
   const [excluirOpen, setExcluirOpen] = useState(false)
   const [editarOpen, setEditarOpen] = useState(false)

   const [codparcColetado, setCodparc] = useState('');
   const [codContatoColetado, setCodContatoColetado] = useState('');
   const [erroDell, setErroDell] = useState(null);
   const [mostrarDeletados, setMostrarDeletados] = useState(false);

   const [enviandoNovoContato, setEnviandoNovoContato] = useState(false);
   const [enviandoEdicao, setEnviandoEdicao] = useState(false);

   const [dadosContato, setDadosContato] = useState({
      nomecontato: '',
      email: '',
      ad_whatsappcp: '',
      ad_isnfe: false,
      ad_iscentregas: false,
      ad_iscomercial: false,
      ad_isprincipal: false,
   });

   const listarContatosParc = (codparc) => {
      setCodparc(codparc);
      whatsappListaContatosFlagsAction({ codparc: codparc });
   };
   //console.log('Whatsapp contatosListGeral payload:', contatosListGeral);

   const listarContatosGeral = (codparc) => {
      setCodparc(codparc);
      WhatsappContatoGeralListAction(({ codparc: codparc }));
   };

   useEffect(() => {
      if (!buscarCodparc) {
         return;
      }

      setOpen(false);
      setSearchValue(buscarCodparc);
      listarContatosParc(buscarCodparc);
      listarContatosGeral(buscarCodparc);
   }, [buscarCodparc, buscarId]);

   const onOpenPopup = () => {
      setOpen(true);
   }
   const onOpenPopupExcluir = (codcontato) => {
      setCodContatoColetado(codcontato);
      setExcluirOpen(true);
   }
   const onOpenPopupSalvar = () => {
      setSalvarOpen(true);
   }
   const onOpenPopupEditar = (codcontato) => {
      setCodContatoColetado(codcontato);
      setEditarOpen(true);
   }

   const isEmail = (email = null) => {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
   }

   //console.log("codusu: ", codusu);

   const handleSave = async () => {
      const { nomecontato, email, ad_whatsappcp, ad_isnfe, ad_iscentregas, ad_iscomercial, ad_isprincipal } = dadosContato;
      const newErrors = [];
      const whatsappWithoutSpaces = dadosContato.ad_whatsappcp.replace(/\s/g, '');
      if (!nomecontato.trim()) {
         newErrors.push('O campo Nome do Contato é obrigatório');
      }
      if (email == '') {
         newErrors.push('O campo E-mail é obrigatório');
      } else {
         if (!isEmail(email)) {
            newErrors.push('O E-mail digitado é inválido');
         }
      }
      if (!dadosContato.ad_whatsappcp.trim()) {
         newErrors.push('O campo Whatsapp é obrigatório')
      } else {
         //console.log("whatsapp: ", whatsapp);
         if (whatsappWithoutSpaces.length < 10) {
            newErrors.push('O número de Whatsapp digitado é inválido');
         }
      }
      if (!ad_isnfe && !ad_iscentregas && !ad_iscomercial && !ad_isprincipal) {
         newErrors.push('É necessária a insersão de pelo menos um flag');
      }
      if (newErrors.length === 0) {

         const payload = {
            codparc: codparcColetado,
            ad_whatsappcp: dadosContato.ad_whatsappcp,
            nomecontato: dadosContato.nomecontato,
            email: dadosContato.email,
            ad_isprincipal: dadosContato.ad_isprincipal ? 'S' : 'N',
            ad_iscomercial: dadosContato.ad_iscomercial ? 'S' : 'N',
            ad_iscentregas: dadosContato.ad_iscentregas ? 'S' : 'N',
            ad_isnfe: dadosContato.ad_isnfe ? 'S' : 'N',
            codusu: codusu ? codusu : null
         };
         setEnviandoNovoContato(true);
         WhatsappInsertContatoParcAction(payload);
      }
      else {
         setErrors(newErrors);
      }
   };

   useEffect(() => {
      if (!contatosParcInsertLoader && enviandoNovoContato) {
         whatsappListaContatosFlagsAction({ codparc: codparcColetado });

           toast.success(
            <div>
               <p style={{ margin: 0 }}><b>Cadastro de novo contato, feita com sucesso!</b></p>
               <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
            </div>,
            {
               position: "top-right",
               autoClose: 4000,
               hideProgressBar: false,
               closeOnClick: true,
               draggable: true,
               progress: undefined,
               style: {
                  background: "#fff",
                  color: "#000",
               },
            }
         );


         setOpen(false);
         setErrors([])

         setEnviandoNovoContato(false);
      }
   }, [contatosParcInsertLoader, WhatsappInsertContatoParcAction, codparcColetado, enviandoNovoContato]);




         //dropdown list de cargos
         const options = [
            { key: 1, text: 'Contato Programado', value: 'Contato Programado' },
            { key: 2, text: 'Controle de Entregas', value: 'Controle de Entregas' },
            { key: 3, text: 'WhatsApp único', value: 'WhatsApp único' },
         ]

   // const contatosPrincipais = (codcontato) => {
   //    return contatos.some(c => c.ad_isprincipal === 'S');
   // }

   const handleChangeContato = (codcontato, e = {}, data = {}) => {
      const name = data?.name || e?.target?.name;
      const type = data?.type || e?.target?.type;
      const value = data?.value ?? e?.target?.value;
      const checked = data?.checked ?? e?.target?.checked;

      if (!name) return;

      setContatos(prev =>
         prev.map(contato =>
            contato.codcontato === codcontato
               ? {
                  ...contato,
                  [name]: type === 'checkbox' ? (checked ? 'S' : 'N') : value
               }
               : contato
         )
      );
   };

   const handleEditar = (codcontato) => {
      const contatoAlterado = contatos.find(c => c.codcontato === codcontato);
      const newErrors = [];

      if (!(contatoAlterado.nomecontato || '').trim()) {
         newErrors.push('O campo Nome do Contato é obrigatório');
      }
      if (!(contatoAlterado.email || '').trim()) {
         newErrors.push('O campo E-mail é obrigatório');
      } else {
         if (!isEmail(contatoAlterado.email)) {
            newErrors.push('O E-mail digitado é inválido');
         }
      }
      if (!(contatoAlterado.ad_whatsappcp || '').trim()) {
         newErrors.push('O campo Whatsapp é obrigatório')
      } else {
         //console.log("whatsapp: ", contatoAlterado.ad_whatsappcp);
         if (contatoAlterado.ad_whatsappcp.replace(/\s/g, '').length < 10) {
            newErrors.push('O número de Whatsapp digitado é inválido');
         }
      }
      if (contatoAlterado.ad_isnfe === 'N' && contatoAlterado.ad_iscentregas === 'N' && contatoAlterado.ad_iscomercial === 'N' && contatoAlterado.ad_isprincipal === 'N') {
         newErrors.push('É necessária a insersão de pelo menos um flag');
      }
      if (newErrors.length === 0) {
         // console.log("codparc editar:", parseInt(codparcColetado));

         const payload = {
            codparc: parseInt(codparcColetado), // <- força número correto
            ad_whatsappcp: contatoAlterado.ad_whatsappcp,
            nomecontato: contatoAlterado.nomecontato,
            email: contatoAlterado.email,
            nunota: contatoAlterado.ad_nunota,
            isprincipal: contatoAlterado.ad_isprincipal === 'S' ? 'S' : 'N',
            iscomercial: contatoAlterado.ad_iscomercial === 'S' ? 'S' : 'N',
            iscentregas: contatoAlterado.ad_iscentregas === 'S' ? 'S' : 'N',
            isnfe: contatoAlterado.ad_isnfe === 'S' ? 'S' : 'N',
            dtfim: null,
            codcontato: contatoAlterado.codcontato,
            codusu: codusu ? codusu : null
         };

         // console.log("PAYLOAD CORRETO:", payload);

         setEnviandoEdicao(true);
         WhatsappUpdateContatoParcAction(payload);
         
         toast.success(
            <div>
               <p style={{ margin: 0 }}><b>Edição concluída!</b></p>
               <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
            </div>,
            {
               position: "top-right",
               autoClose: 4000,
               hideProgressBar: false,
               closeOnClick: true,
               draggable: true,
               progress: undefined,
               style: {
                  background: "#fff",
                  color: "#000",
               },
            }
         );

      } else {

         setErrors(newErrors);
         toast.error(
            <div>
               <p style={{ margin: 0 }}><b>Erro indetificado!</b></p>
               <p style={{ margin: 0 }}>
                  <ul>
                     {newErrors.map((error, index) => (
                        <li key={index}>{error}</li>
                     ))}
                  </ul>
               </p>
               <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
            </div>,
            {
               position: "top-right",
               autoClose: 4000,
               hideProgressBar: false,
               closeOnClick: true,
               draggable: true,
               progress: undefined,
               style: {
                  background: "#fff",
                  color: "#000",
               },
            }
         )
      }
   };

   const handleApagar = (codcontato) => {

      const dateFim = new Date().toISOString();
      const novaLista = contatos.map((contato) =>
         contato.codcontato === codcontato
            ? { ...contato, ad_dtfim: dateFim }
            : contato,
      );

      // console.log(dateFim);
      // console.log("nova lista", novaLista);

      setContatos(novaLista)
      const contatoAlterado = novaLista.find(c => c.codcontato === codcontato);

      const payload = {
         codparc: parseInt(codparcColetado),
         nomecontato: contatoAlterado.nomecontato,
         ad_whatsappcp: contatoAlterado.ad_whatsappcp,
         email: contatoAlterado.email,
         nunota: contatoAlterado.ad_nunota,
         isprincipal: contatoAlterado.ad_isprincipal === 'S' ? 'N' : 'N',
         iscomercial: contatoAlterado.ad_iscomercial === 'S' ? 'S' : 'N',
         iscentregas: contatoAlterado.ad_iscentregas === 'S' ? 'S' : 'N',
         isnfe: contatoAlterado.ad_isnfe === 'S' ? 'S' : 'N',
         dtfim: contatoAlterado.ad_dtfim,
         codcontato: contatoAlterado.codcontato,
         codusu: codusu ? codusu : null
      };

      //console.log('comercial ->', contatoAlterado.ad_iscomercial)

      WhatsappUpdateContatoParcAction(payload)
      whatsappListaContatosFlagsAction({ codparc: codparcColetado });


      toast.success(
         <div>
            <p style={{ margin: 0 }}><b>Exclusão concluída!</b></p>
            <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
         </div>,
         {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
            style: {
               background: "#fff",
               color: "#000",
            },
         }
      )
   };

   useEffect(() => {
      if (!contatosParcUpdateLoader && enviandoEdicao) {
         whatsappListaContatosFlagsAction({ codparc: codparcColetado });

         setEditarOpen(false);
         setErrors([])
      }
   }, [contatosParcUpdateLoader, WhatsappUpdateContatoParcAction, codparcColetado, enviandoEdicao]);

   return (
      <>
         <ToastContainer />
         <Modal
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}

         >
            <ModalHeader>Adicionar Novo Contato</ModalHeader>
            {successMessage && (
               <Message success header="Sucesso!" content={successMessage} />
            )}
            {errors.length > 0 && (
               <Message
                  error
                  header="Houve alguns erros com o seu envio"
                  list={errors} // Exibe os erros aqui
               />
            )}
            <ModalContent image scrolling>
               <ModalDescription>
                  <Card.Group>
                     <Card fluid>
                        <Divider hidden />
                        <Card.Content>
                           <Card.Description>
                              <Form size={'mini'} key={'mini'}>
                                 <Form.Group widths='equal'>
                                    <Form.Field
                                       name='nomecontato'
                                       control='input'
                                       maxLength={40}
                                       placeholder='Nome do Contato'
                                       value={dadosContato.nomecontato}
                                       onChange={(e) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             nomecontato: e.target.value
                                          }))
                                       }
                                    />
                                 </Form.Group>
                                 <Form.Group widths='equal'>
                                    <Form.Field
                                       name='email'
                                       control='input'
                                       maxLength={80}
                                       placeholder='Email'
                                       value={dadosContato.email}
                                       onChange={(e) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             email: e.target.value
                                          }))
                                       }
                                    />
                                    <PatternFormat icon='hashtag' iconPosition='left'
                                       customInput={Form.Field}
                                       control='input'
                                       format="## ##### ####"
                                       placeholder='Whatsapp 99 99999 9999'
                                       value={dadosContato.ad_whatsappcp}
                                       onChange={(e) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             ad_whatsappcp: e.target.value
                                          }))
                                       }
                                    //onChange={e => setDocumentNumber(e.target.value.replace(/[^0-9]/g, ''))}
                                    // labelPosition='right corner'
                                    />
                                    {/* <Form.Field
                                                    control='input'
                                                    placeholder='WhatsApp 99 99999-9999'
                                                    onChange={(e) => handleInputChange('whatsapp', e.target.value)}
                                                /> */}
                                 </Form.Group>


                                 <FormGroup className='inputCheckbox' inline>
                                    <FormCheckbox label='Nfe' style={{ width: '100%' }} name='ad_isnfe'
                                       checked={dadosContato.ad_isnfe === 'S'}
                                       onChange={(e, data) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             ad_isnfe: data.checked ? 'S' : 'N'
                                          }))
                                       } />

                                    <FormCheckbox label='Entrega' style={{ width: '100%' }} name='ad_iscentregas'
                                       checked={dadosContato.ad_iscentregas === 'S'}
                                       onChange={(e, data) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             ad_iscentregas: data.checked ? 'S' : 'N'
                                          }))
                                       } />

                                    <FormCheckbox label='Comercial' style={{ width: '100%' }} name='ad_iscomercial'
                                       checked={dadosContato.ad_iscomercial === 'S'}
                                       onChange={(e, data) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             ad_iscomercial: data.checked ? 'S' : 'N'
                                          }))
                                       } />

                                    <FormCheckbox label='Principal' style={{ width: '100%' }} name='ad_isprincipal'
                                       checked={dadosContato.ad_isprincipal === 'S'}
                                       onChange={(e, data) =>
                                          setDadosContato(prev => ({
                                             ...prev,
                                             ad_isprincipal: data.checked ? 'S' : 'N'
                                          }))
                                       } />  {/*disabled={contatosPrincipais() ? true : false} */}

                                 </FormGroup>
                              </Form>
                              <Divider hidden />
                              <Divider hidden />
                              <Divider hidden />
                           </Card.Description>
                        </Card.Content>
                     </Card>
                  </Card.Group>
               </ModalDescription>
            </ModalContent>
            <ModalActions>
               <Button onClick={() => {
                  setOpen(false); setErrors([]); setDadosContato({
                     nomecontato: '',
                     email: '',
                     ad_whatsappcp: '',
                     ad_isnfe: 'N',
                     ad_iscentregas: 'N',
                     ad_iscomercial: 'N',
                     ad_isprincipal: 'N',
                  });
               }}
                  color='red'
                  icon='close'
                  labelPosition='right'
                  negative
                  content="Cancelar"
               >
               </Button>
               <Button color='green'
                  icon='check'
                  labelPosition='right'
                  positive
                  content="Salvar"
                  onClick={
                     handleSave
                  } loading={contatosParcInsertLoader}>

               </Button>
            </ModalActions>
         </Modal >

         <Modal
            size='mini'
            open={excluirOpen}
            onClose={() => setExcluirOpen(false)}
            onOpen={() => setExcluirOpen(true)}
         >
            <ModalHeader>Salvar Alteração</ModalHeader>
            <ModalContent>
               <p>Tem certeza de que deseja excluir este contato?</p>
            </ModalContent>
            <ModalActions>
               <Button negative onClick={() => setExcluirOpen(false)}>
                  Não
               </Button>
               <Button positive onClick={() => {
                  handleApagar(codContatoColetado);

                  setExcluirOpen(false);
               }} loading={contatosParcUpdateLoader}>
                  Sim
               </Button>
            </ModalActions>
         </Modal>

         <Modal
            size='mini'
            open={editarOpen}
            onClose={() => setEditarOpen(false)}
            onOpen={() => setEditarOpen(true)}
         >
            <ModalHeader>Salvar Alteração</ModalHeader>
            <ModalContent>
               <p>Tem certeza de que deseja Editar este Contato?</p>
            </ModalContent>
            <ModalActions>
               <Button negative onClick={() => setEditarOpen(false)}>
                  Não
               </Button>
               <Button positive onClick={() => {
                  handleEditar(codContatoColetado);

                  setEditarOpen(false);
               }} loading={contatosParcUpdateLoader}>
                  Sim
               </Button>
            </ModalActions>
         </Modal>

         <Header as='h3' dividing>
            <Icon name='whatsapp' color='green' />
            <HeaderContent>
               WhatsApp
               <HeaderSubheader>Cadastre WhatsApp no Parceiro para receber informações</HeaderSubheader>
            </HeaderContent>
         </Header>
         <div className="ui input icon loading">
            <DebounceInput
               name='codparc'
               minLength={2}
               debounceTimeout={4000}
               onChange={(e) => {
                  setOpen(false);
                  setSearchValue(e.target.value);
                  //whatsappContatoChangeFieldAction(e);
                  listarContatosParc(e.target.value);
                  listarContatosGeral(e.target.value);
               }}

               maxLength={9}
               placeholder="Código do Parceiro..."
               value={searchValue}
            />
            {contatosLoading ? (<i aria-hidden="true" className="spinner icon"></i>) : (<div></div>)}
         </div>
         <Divider hidden />

         {codparcColetado !== null && codparcColetado !== '' && (
            <Button color='green' fluid onClick={() => onOpenPopup()}>
               <Icon name='plus' />
               Adicionar Novo Contato
            </Button>)}
         <>
            <Divider hidden />
            {codparcColetado !== null && codparcColetado !== '' && (
               <Button className='btnDel' onClick={() => setMostrarDeletados(prev => !prev)} >
                  {mostrarDeletados ? "Ocultar deletados" : "Mostrar deletados"}
               </Button>
            )}
            <Divider hidden />

            <BrowserView>

               <div style={{ display: 'flex', gap: '16px' }}>
                  <Card.Group>
                     {contatos.filter(item => mostrarDeletados || (item.ad_dtfim === null || item.ad_dtfim === undefined)).map((dados) => (
                        //contato.dados.map((dados) => (

                        <Card fluid
                           key={dados.codcontato}
                           style={{ flex: '1 0 539px', marginBottom: '16px', }}
                           className={dados.ad_dtfim ? 'dtfimTrue' : 'dtfimFalse'}
                        >

                           <Card.Content>
                              <Card.Description>
                                 <Label attached='top left'>{dados.codcontato}</Label>
                                 <Form size={'mini'} key={'mini'}>
                                    <FormGroup className='inputCheckboxEdit' inline>

                                       <FormCheckbox label='Nfe' style={{ width: '100%' }} name='ad_isnfe' checked={dados.ad_isnfe == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                       <FormCheckbox label='Entrega' style={{ width: '100%' }} name='ad_iscentregas' checked={dados.ad_iscentregas == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                       <FormCheckbox label='Comercial' style={{ width: '100%' }} name='ad_iscomercial' checked={dados.ad_iscomercial == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                       <FormCheckbox
                                          label='Principal'
                                          style={{ width: '100%' }}
                                          name='ad_isprincipal'
                                          checked={dados.ad_isprincipal === 'S'}
                                          onChange={
                                             (e, data) => {
                                                const novoValor = data.checked ? 'S' : 'N';

                                                const novaLista = contatos.map((contato) => {
                                                   if (novoValor === 'S') {
                                                      return {
                                                         ...contato,
                                                         ad_isprincipal: contato.codcontato === dados.codcontato ? 'S' : 'N'
                                                      };
                                                   }

                                                   if (contato.codcontato === dados.codcontato) {
                                                      return { ...contato, ad_isprincipal: 'N' }
                                                   }

                                                   return contato;
                                                });
                                                setContatos(novaLista);
                                                handleChangeContato(dados.codcontato, e, data)
                                             }
                                          } //disabled={dados.ad_isprincipal == 'S' ? false : contatosPrincipais(dados.codcontato)}
                                          disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}
                                       />
                                    </FormGroup>
                                    <Form.Group widths='equal'>
                                       <Form.Field
                                          name='nomecontato'
                                          control='input'
                                          maxLength={40}
                                          placeholder='Nome do Contato'
                                          error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'nomecontato')}

                                          value={dados.nomecontato || ''}
                                          onChange={(e) => handleChangeContato(dados.codcontato, e)}
                                          disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}
                                       />
                                       {/* <Form.Field >
                                          <Dropdown
                                             name='cargo'
                                             value={dados.cargo}
                                             options={options}
                                             placeholder='Cargo'
                                             selection
                                             dados={dados}
                                             onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)}
                                             disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}
                                          />
                                       </Form.Field> */}
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                       <Form.Field
                                          name='email'
                                          control='input'
                                          placeholder='Email'
                                          error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'email')}
                                          maxLength={80}
                                          value={dados.email}
                                          onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)}
                                          disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}

                                       />
                                       <PatternFormat icon='hashtag' iconPosition='left'
                                          name='ad_whatsappcp'
                                          customInput={Form.Field}
                                          control='input'
                                          format="## ##### ####"
                                          error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'ad_whatsappcp')}
                                          placeholder='Whatsapp 99 99999 9999'
                                          value={dados.ad_whatsappcp}
                                          onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)}
                                          disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined ? true : false}
                                       />
                                    </Form.Group>
                                 </Form>
                              </Card.Description>
                           </Card.Content>
                           <Card.Content extra>
                              <div className='ui two buttons'>
                                 <Button basic color='green' onClick={() => {
                                    onOpenPopupEditar(dados.codcontato)
                                    //handleEditar(dados.codcontato);

                                 }} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}>
                                    Salvar
                                 </Button>
                                 <Button basic color='red' onClick={() => {
                                    onOpenPopupExcluir(dados.codcontato);

                                 }} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}>
                                    Excluir
                                 </Button>
                              </div>
                           </Card.Content>
                        </Card>
                        //))
                     ))}
                  </Card.Group>
               </div>
            </BrowserView>
         </>


         <MobileView>
            <div >
               <Card.Group>
                  {contatos.filter(item => mostrarDeletados || (item.ad_dtfim === null || item.ad_dtfim === undefined)).map((dados) => (
                     <Card fluid key={dados.codcontato} className={dados.ad_dtfim ? 'dtfimTrue' : 'dtfimFalse'}>
                        <Card.Content>
                           <Card.Description>
                              <Label attached='top left'>{dados.codcontato}</Label>
                              <Form size={'mini'} key={'mini'}>
                                 <FormGroup className='inputCheckboxEdit' inline>
                                    <FormCheckbox label='Nfe' style={{ width: '100%' }} name='ad_isnfe' checked={dados.ad_isnfe == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                    <FormCheckbox label='Entrega' style={{ width: '100%' }} name='ad_iscentregas' checked={dados.ad_iscentregas == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                    <FormCheckbox label='Comercial' style={{ width: '100%' }} name='ad_iscomercial' checked={dados.ad_iscomercial == 'S' ? true : false} onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined} />

                                    <FormCheckbox
                                       label='Principal'
                                       style={{ width: '100%' }}
                                       name='ad_isprincipal'
                                       checked={dados.ad_isprincipal === 'S'}
                                       onChange={
                                          (e, data) => {
                                             const novoValor = data.checked ? 'S' : 'N';

                                             const novaLista = contatos.map((contato) => {
                                                if (novoValor === 'S') {
                                                   return {
                                                      ...contato,
                                                      ad_isprincipal: contato.codcontato === dados.codcontato ? 'S' : 'N'
                                                   };
                                                }

                                                if (contato.codcontato === dados.codcontato) {
                                                   return { ...contato, ad_isprincipal: 'N' }
                                                }

                                                return contato;
                                             });
                                             setContatos(novaLista);
                                             handleChangeContato(dados.codcontato, e, data)
                                          }
                                       } //disabled={dados.ad_isprincipal == 'S' ? false : contatosPrincipais(dados.codcontato)}
                                       disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}
                                    />
                                 </FormGroup>
                                 <Form.Group widths='equal'>
                                    <Form.Field
                                       name='nomecontato'
                                       control='input'
                                       maxLength={40}
                                       placeholder='Nome do Contato'
                                       error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'nomecontato')}

                                       value={dados.nomecontato || ''}
                                       onChange={(e) => handleChangeContato(dados.codcontato, e)}
                                       disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}
                                    />
                                 </Form.Group>
                                 <Form.Group widths='equal'>
                                    <Form.Field
                                       name='email'
                                       control='input'
                                       placeholder='Email'
                                       error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'email')}
                                       maxLength={80}
                                       value={dados.email}
                                       onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)}
                                       disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}

                                    />
                                    <PatternFormat icon='hashtag' iconPosition='left'
                                       name='ad_whatsappcp'
                                       customInput={Form.Field}
                                       control='input'
                                       format="## ##### ####"
                                       error={errorSaving.some(a => a.codcontato === dados.codcontato && a.campo == 'ad_whatsappcp')}
                                       placeholder='Whatsapp 99 99999 9999'
                                       value={dados.ad_whatsappcp}
                                       onChange={(e, data) => handleChangeContato(dados.codcontato, e, data)}
                                       disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined ? true : false}
                                    />
                                 </Form.Group>
                              </Form>
                           </Card.Description>
                        </Card.Content>
                        <Card.Content extra>
                           <div className='ui two buttons'>
                              <Button basic color='green' onClick={() => {
                                 onOpenPopupEditar(dados.codcontato)
                                 //handleEditar(dados.codcontato);

                              }} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}>
                                 Salvar
                              </Button>
                              <Button basic color='red' onClick={() => {
                                 onOpenPopupExcluir(dados.codcontato);

                              }} disabled={dados.ad_dtfim !== null && dados.ad_dtfim !== undefined}>
                                 Excluir
                              </Button>
                           </div>
                        </Card.Content>
                     </Card>
                  ))}
               </Card.Group>
            </div>
         </MobileView>

         <style>
            {`
                    .ui.form .inline.fields{
                        display: flex;
                        justify-content: space-between;
                        width: 50%;
                        margin-top: 3em;
                    }


                    .ui.form .inline.fields.inputCheckboxEdit{
                        width: 100%;
                        margin-bottom: 2em;
                    }

                    @media (max-width: 768px) {
                        .ui.form .inline.fields {
                            width: 100%;
                        }
                    }

                    .ui.checkbox label:before,
                    .ui.checkbox:hover label {
                        cursor: pointer;
                        background: transparent;
                        transition: all 0.2s ease;
                    }
                        

                    .ui.checkbox input[type=checkbox]:checked ~ label:before {
                        border-color: #21BA45;
                        background: transparent;
                        transition: all 0.2s ease;
                        color: #21BA45 !important;
                    }

                    .ui.checkbox input[type=checkbox] ~ label:after {
                        transition: all 0.2s ease;
                        background: #21BA45 !important;
                        color: #fff !important;
                    }
                    .ui.checkbox input[type=checkbox]:checked ~label:after{
                        border-color: #21BA45;
                        background: #21BA45 !important;
                        color: #fff !important;
                     }

                    .ui.checkbox input[type=checkbox]:checked ~label {
                        color: #21BA45 !important;
                    }

                    .ui.cards>.dtfimTrue{
                        background-color: #ebebeb !important;
                    }
                                        
                `}

         </style>

      </>

   )

}

const mapStateToProps = (state) => ({
   contatosList: state.WhatsappReducer.contatosList,
   contatosLoading: state.WhatsappReducer.contatosLoading,

   contatosListGeral: state.WhatsappReducer.contatosListGeral,
   contatosGeralLoading: state.WhatsappReducer.contatosGeralLoading,

   codigoConsultor: state.LoginReducer.codigoConsultor,

   contatosParcUpdate: state.WhatsappReducer.contatosParcUpdate,
   contatosParcUpdateLoader: state.WhatsappReducer.contatosParcUpdateLoader,

   contatosParcInsert: state.WhatsappReducer.contatosParcInsert,
   contatosParcInsertLoader: state.WhatsappReducer.contatosParcInsertLoader,

   mensagem: state.WhatsappReducer.mensagem,
   status: state.WhatsappReducer.status,
   codparc: state.WhatsappReducer.codparc,

   codusu: state.LoginReducer.codusu
})

export default connect(mapStateToProps, {
   //whatsappListaContatosAction,
   whatsappListaContatosFlagsAction,
   WhatsappUpdateContatoParcAction,
   WhatsappInsertContatoParcAction,
   WhatsappContatoGeralListAction
}
)(Whatsapp);

